import i18n, { type InitOptions, type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import de from './de.json';
import en from './en.json';

export const SUPPORTED_LANGS = ['de', 'en'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

const resources: Resource = {
  de: { translation: de },
  en: { translation: en },
};

const isDev = import.meta.env.DEV;

const options: InitOptions = {
  resources,
  fallbackLng: 'de',
  supportedLngs: SUPPORTED_LANGS as unknown as string[],
  nonExplicitSupportedLngs: true,
  interpolation: { escapeValue: false },
  detection: {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'lang',
    caches: ['localStorage'],
  },
  // Surface untranslated keys loudly in dev so they're caught before merge.
  saveMissing: isDev,
  missingKeyHandler: isDev
    ? (lngs, ns, key) => {
        console.warn(`[i18n] missing key: ${ns}:${key} (${lngs.join(',')})`);
      }
    : undefined,
};

void i18n.use(LanguageDetector).use(initReactI18next).init(options);

export default i18n;
